import { request } from '../request';

export function reportAnIssue(description: string, attachments: File[]) {
  const formData = new FormData();
  formData.append('description', description);
  attachments.forEach((file) => formData.append('attachments', file));

  return request.post<void>(`/v1/issues/report`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
